<template>
  <div class="input-wrapper">
    <span class="input-error-box" v-show="errors.has(name)">{{ errors.first(name) ? errors.first(name).replace('_', ' ') : errors.first(name) }}</span>
    <label :for="id" class="input--checkbox">
      <input
        :id="id"
        type="checkbox"
        :name="name"
        :checked="checked"
        @input="$emit('input', $event.target.checked)"
        :class="classes"
        v-validate="required"
      />
      <div class="input--checkbox--check"></div>
      <span v-html="label"></span>
    </label>
  </div>
</template>

<script>

export default {
  name: 'Checkbox',
  data: () => ({
    val: null
  }),
  components: {
  },
  computed: {
  },
  props: {
    id: { type: String , required: false, default: null },
    value: { type: [String, Boolean], required: false, default: null },
    label: { type: String, required: false, default: null },
    name: { type: String, required: false, default: null },
    checked: { type: Boolean, required: false, default: false },
    classes: { type: String, required: false, default: null },
    required: { type: String, required: false, default: null }
  },
  mounted () {
  },
  created () {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../scss/global/includes";

.input-wrapper {
    display: inline-block;
    position: relative;
}

.input-wrapper .input--checkbox input {
  visibility: hidden;
  width: 0px;
  height: 0px;
  overflow: hidden;
  margin: 0;
  padding: 0;
  line-height: 0;
  appearance: none;

  &:checked + div.input--checkbox--check {

    &:after {
      margin-top: -3px;
      width: 5px;
      display: block;
      height: 9px;
      border: solid $primary-grey;
      border-width: 0 2px 2px 0;
      -webkit-transform: rotate(45deg);
      -ms-transform: rotate(45deg);
      transform: rotate(45deg);
      content: "";
    }
  }
}

.input-wrapper .input--checkbox {
  display: flex;
  align-items: flex-start;
  line-height: 1.2;

  a, ::v-deep a {
    color: $primary;
  }
}

.input--checkbox--check {
  margin-left: 0px;
  width: 16px;
  height: 16px;
  min-width: 16px;
  margin-top: 2px;
  background: transparent;
  border: 1px solid $primary-grey;
  margin-right: 10px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}


</style>
